import React from 'react'
import PropTypes from 'prop-types'
import { formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import ConfigureRateLimits from './configure-rate-limits'
import {
  getUserRateLimits,
  deleteUserRateLimits,
  addUserRateLimits
} from './rate-limit-requests'
import { isEmpty, complement } from 'ramda'

export class ConfigureRateLimitsContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      rateLimits: undefined
    }
    this.handleSave = this.handleSave.bind(this)
    this.handleReset = this.handleReset.bind(this)
  }

  async handleSave (ownerId, rateLimits) {
    await deleteUserRateLimits(ownerId)
    this.setState({
      rateLimits: []
    })

    const hasRateLimits = complement(isEmpty)(rateLimits)

    if (hasRateLimits) {
      const response = await addUserRateLimits(ownerId, rateLimits)
      this.setState({
        rateLimits: response
      })
    }
  }

  async handleReset (ownerId) {
    await deleteUserRateLimits(ownerId)
    this.setState({
      rateLimits: []
    })
  }

  async componentWillReceiveProps (nextProps) {
    if (nextProps.ownerId !== this.props.ownerId) {
      const rateLimits = await getUserRateLimits(nextProps.ownerId)
      this.setState({
        rateLimits
      })
    }
  }

  async componentDidMount () {
    if (this.props.ownerId) {
      const rateLimits = await getUserRateLimits(this.props.ownerId)
      this.setState({
        rateLimits
      })
    }
  }

  render () {
    return (
      <div>
        {this.state.rateLimits && (
          <ConfigureRateLimits
            {...this.state}
            ownerId={this.props.ownerId}
            endDate={this.props.endDate}
            handleSave={this.handleSave}
            handleReset={this.handleReset}
            isPristine
          />
        )}
      </div>
    )
  }
}

ConfigureRateLimitsContainer.propTypes = {
  ownerId: PropTypes.string,
  endDate: PropTypes.number
}

const selector = formValueSelector('widget')

const RateLimits = connect((state, props) => ({
  ownerId: selector(state, 'ownerId'),
  endDate: selector(state, 'endDate')
}))(ConfigureRateLimitsContainer)

export default RateLimits



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-rate-limits/container.js